window.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    function loadScript() {
      // <!-- Nextop LiveChat {literal} -->
      (function(d,w,c){w.NextopLiveChatID='LIVECHAT:1758792152404:760985293907533824';w[c]=w[c]||function(){(w[c].q=w[c].q||[]).push(arguments)};var s=d.createElement('script');s.async=true;s.src='https://livechat.nextop.com/nextop-im-sdk.min.js';if(d.head)d.head.appendChild(s)})(document,window,'NextopLiveChat');
      // <!-- / Nextop LiveChat {/literal} -->

      window.removeEventListener('scroll', loadScript);
    }
    window.addEventListener('scroll', loadScript);

    // <!-- Meta Pixel Code -->
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '1514906480081092');
    fbq('track', 'PageView');
    // <!-- End Meta Pixel Code -->
  }, 0);
})